"use client";

import React from "react";
import { WobbleCard } from "../ui/wobble-card.tsx";
import XpertGear from "../../assets/ProjectImages/WebDev/XpertGear Desktop-min.png";

import react from "../../assets/atom.png";
import csharp from "../../assets/c-sharp.png";
import java from "../../assets/java.png";
import sql from "../../assets/sql.png";
import python from "../../assets/python.png";
import figma from "../../assets/figma.png";
import shopify from "../../assets/shopify.png";
import tailwind from "../../assets/tailwind-css.png";
import visual from "../../assets/visual-studio-code.png";
import cape from "../../assets/Cape Town.jpg";
import pycharm from "../../assets/pycharm.png";
import netbeans from "../../assets/apache-netbeans.png";

export function WobbleCardDemo() {
  const blueStyleFont = "child-element sm:text-cyan-300 md:text-white md:group-hover:text-cyan-300";
  const smallIconStyles = "inline sm:grayscale-0 md:grayscale md:group-hover:grayscale-0 h-5 w-5"

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 max-w-7xl mx-auto w-full">
      <WobbleCard
        containerClassName="col-span-1 lg:col-span-2 h-full bg-black h-[400px] lg:min-h-[300px]"
        className=""
      >
        <div className="max-w-xs">
          <h2 className="text-left text-balance text-base md:text-xl lg:text-3xl font-semibold tracking-[-0.015em] text-white">
            About Me
          </h2>
          <p className="mt-2 text-left  text-base/6 text-neutral-200">
            Hello, I'm <span className={blueStyleFont}>Tshepo</span> Maseeme.
            <br />
            A <span className={blueStyleFont}>frontend-focused</span> software developer and <span className={blueStyleFont}></span>student.
            <br />
            I also have experience tinkering with <span className={blueStyleFont}> databases</span> and <span className={blueStyleFont}>designing</span> webpages.
          </p>
        </div>
        <img
          src={XpertGear}
          width={300}
          height={300}
          alt="Xpertgear Shopify Site"
          className="absolute child-element right-4 lg:-right-[10%] group-hover:grayscale-0 md:grayscale sm:grayscale-0 duration-10000 filter -bottom-10 object-contain rounded-2xl"
        />
      </WobbleCard>
      <WobbleCard containerClassName="col-span-1 min-h-[300px]">
        <h2 className="max-w-80 text-left text-balance text-base md:text-xl lg:text-3xl font-semibold tracking-[-0.015em] text-white">
          Technologies
        </h2>
        <p className="mt-4 max-w-[26rem] text-left text-base/6 text-neutral-200">
          I mainly work with <img src={react} alt="#" className={smallIconStyles} /> React and <img src={tailwind} alt="#" className={smallIconStyles} /> Tailwind CSS, but my skill set includes;
          <br />
          <img src={csharp} alt="#" className={smallIconStyles} />C#, <img src={java} alt="#" className={smallIconStyles} />Java, <img src={python} alt="#" className={smallIconStyles} /> Python, and  <img src={sql} alt="#" className={smallIconStyles} />SQL.
          <br />
          I'm also familiar with <img src={figma} alt="#" className={smallIconStyles} />Figma, <img src={shopify} alt="#" className={smallIconStyles} />Shopify, PyQt5, <br/> and Tkinter.
          <br />
          On the following IDE's;
          <br />
          <img src={visual} alt="#" className={smallIconStyles} />Visual Studio Code, <img src={pycharm} alt="#" className={smallIconStyles} />PyCharm, IntelliJ Idea, and <img src={netbeans} alt="#" className={smallIconStyles} />Netbeans.
          <br />
        </p>
      </WobbleCard>
      <WobbleCard containerClassName="col-span-1 lg:col-span-3 bg-black h-[300px] lg:h-[300px] xl:h-[300px]">
        <div className="max-w-sm">
          <h2 className="max-w-sm md:max-w-lg text-left text-balance text-base md:text-xl lg:text-3xl font-semibold tracking-[-0.015em] text-white">
            My Background
          </h2>
          <p className="mt-4 max-w-[26rem] text-left  text-base/6 text-neutral-200">
            I live in <span className={blueStyleFont}>South Africa</span>.
            <br />
            I've just recently graduated with a Diploma in <span className={blueStyleFont}>Information Technology</span>.
          </p>
        </div>
        <img
          src={cape}
          width={200}
          height={200}
          alt="linear demo"
          className="absolute sm:right-[-30%] sm:bottom-[-60%] md:bottom-[-30%] md:-right-[1%] lg:-right-[2%] group-hover:grayscale-0 md:grayscale sm:grayscale-0 filter -bottom-10 object-contain rounded-2xl"
        />
      </WobbleCard>
    </div>
  );
}
